module.exports = __webpack_public_path__ + "img/icon_landing_success@3x.8566ece4.png";